import { SafeString } from 'handlebars/dist/handlebars';

export function cFeatureTitle(options) {
  return new SafeString(`<h4 class="c-feature__title">${options.fn(this)}</h4>`);
}
